/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Col_SourceInputs */

const en_admin_funnel_col_source = /** @type {(inputs: Admin_Funnel_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Admin_Funnel_Col_SourceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_col_source = /** @type {((inputs?: Admin_Funnel_Col_SourceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Col_SourceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_col_source(inputs)
});
export { admin_funnel_col_source as "admin.funnel.col.source" }